import { ShopPage } from '@/pages/shop';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/shop')({
	component: ShopPage,
});
